import React, {useState} from "react";
import { IconType } from 'react-icons';
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import useOutsideClickHandler from "hooks/useOutsideClickHandler";
import './index.css';

type Dropdown3Props = {
    children?: React.ReactNode;
    className?: string;
    data: any[];
    dataKey?: string;
    onSelect: (value: any) => void;
    placeholder?: string;
    required?: boolean;
    value?: any;
    Icon?: IconType;
}

function Dropdown3 ({
    children,
    className,
    data,
    dataKey,
    onSelect,
    placeholder,
    value, 
    Icon
}: Dropdown3Props) {
    const [isOpen, setIsOpen] = useState(false);
    const ref = useOutsideClickHandler(()=> setIsOpen(false));

    const selectItem = (item: any) => {
        onSelect(item);
        setIsOpen(false);
    }

    return (
        <div
            className={isOpen
                ? `dropdown3--open ${className}`
                : `dropdown3 ${className}`
            }
            ref={ref}
        >
            <div className="dropdown3__value" onClick={() => setIsOpen(!isOpen)}>
                {value
                    ?   <p>{value}</p>
                    :   placeholder
                    ?   <p className="dropdown3__placeholder">
                          {placeholder}
                        </p>
                    :   ''
                }
                {isOpen &&
                    <div className="dropdown3__items">
                        {data.map((item, i) => (
                            <p
                                key={i}
                                className={ value === item
                                    ? 'dropdown__item dropdown__itemSelected'
                                    : 'dropdown__item'
                                }
                                onClick={()=> selectItem(item)}
                            >
                                {dataKey ? item[dataKey] : item}
                            </p>
                        ))}
                    </div>
                }
                {Icon
                    ? <Icon className='dropdown3__icon2' />
                    : isOpen
                    ? <FaChevronUp className='dropdown3__icon' />
                    : <FaChevronDown className='dropdown3__icon' />
                }
            </div>
        </div>
    )
}

export default Dropdown3